import { c as _c } from "react/compiler-runtime";
import { usePromosPlacementEngine } from "modules/promos/hooks/usePromosPlacementEngine";
import { useEffect } from "react";
import { Creative } from "modules/promos/components/Slot/Creative";
import { useHasBeenInViewport } from "common/hooks/interaction/useHasBeenInViewport";
import type { PromoDataProps } from "modules/promos/types";
import { trackPromoEvent, PromoTrackingEvent } from "modules/promos/lib/tracking";
import { setUTMParams } from "common/lib/utm/setUtmParams";
import { useRegionConfig } from "modules/i18n/hooks/useRegionConfig";
import { trackPromoEngaged, trackPromoViewed } from "common/lib/tcEventCollector";
import { navigateWindowLocation } from "@theconversation/shared-libraries/windowLocation";
interface RendererProps {
  promo: PromoDataProps;
}

/**
 * Component that will render a themed promo creative, attaching placement engine events to it.
 */
export const Renderer = t0 => {
  "use memo";

  const $ = _c(22);
  const {
    promo
  } = t0;
  const {
    events: t1
  } = usePromosPlacementEngine();
  const {
    onClose,
    onView,
    onClick
  } = t1;
  const {
    setRef: creativeRef,
    hasBeenInViewport
  } = useHasBeenInViewport(100);
  const regionConfig = useRegionConfig();
  let t2;
  if ($[0] !== hasBeenInViewport || $[1] !== onView || $[2] !== promo) {
    t2 = () => {
      if (hasBeenInViewport) {
        trackPromoEvent(promo, PromoTrackingEvent.Impression);
        trackPromoViewed(promo.promoId.toString(), promo.type);
        onView(promo);
      }
    };
    $[0] = hasBeenInViewport;
    $[1] = onView;
    $[2] = promo;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== hasBeenInViewport || $[5] !== onView || $[6] !== promo || $[7] !== regionConfig) {
    t3 = [promo, onView, hasBeenInViewport, regionConfig];
    $[4] = hasBeenInViewport;
    $[5] = onView;
    $[6] = promo;
    $[7] = regionConfig;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  useEffect(t2, t3);
  let t4;
  if ($[9] !== onClick || $[10] !== promo) {
    t4 = () => {
      trackPromoEvent(promo, PromoTrackingEvent.Engagement);
      trackPromoEngaged(promo.promoId.toString(), promo.type);
      onClick(promo);
      if (promo.data?.href) {
        const hrefWithUTMParams = setUTMParams(promo.data.href, {
          campaign: promo.campaign?.name,
          medium: promo.type,
          content: `promo-${promo.promoId}`
        });
        setTimeout(() => {
          navigateWindowLocation(hrefWithUTMParams);
        }, 5);
      }
    };
    $[9] = onClick;
    $[10] = promo;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] !== onClose || $[13] !== promo) {
    t5 = () => {
      trackPromoEvent(promo, PromoTrackingEvent.Dismiss);
      onClose(promo);
    };
    $[12] = onClose;
    $[13] = promo;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  let t6;
  if ($[15] !== t4 || $[16] !== t5) {
    t6 = {
      onClick: t4,
      onClose: t5
    };
    $[15] = t4;
    $[16] = t5;
    $[17] = t6;
  } else {
    t6 = $[17];
  }
  const events = t6;
  let t7;
  if ($[18] !== creativeRef || $[19] !== events || $[20] !== promo) {
    const creativeProps = {
      promo,
      events,
      creativeRef
    };
    t7 = <Creative {...creativeProps} />;
    $[18] = creativeRef;
    $[19] = events;
    $[20] = promo;
    $[21] = t7;
  } else {
    t7 = $[21];
  }
  return t7;
};